import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
  paper: {
    padding: '12px 0px'
  }
});

const BaseWidgetActionsPopper = ({ children, anchorEl, isOpen, ...rest }) => {
  const classes = useStyles();
  return (
    <Popper open={isOpen} placement="left-start" anchorEl={anchorEl} transition {...rest} style={{zIndex:1300}}>
      <Paper elevation={2} className={classes.paper}>
        {children}
      </Paper>
    </Popper>
  );
};

BaseWidgetActionsPopper.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  anchorEl: PropTypes.node
};

BaseWidgetActionsPopper.defaultProps = {
  isOpen: false,
  anchorEl: null
};

export default BaseWidgetActionsPopper;
